var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResultantMembers({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.978 10.007a.616.616 0 0 0-.04.87 4.047 4.047 0 0 1 1.021 2.735c0 .408-1.278 1.157-3.367 1.157s-3.367-.75-3.367-1.158a4.11 4.11 0 0 1 1.007-2.721.618.618 0 0 0-.327-1.014.61.61 0 0 0-.582.19A5.288 5.288 0 0 0 1 13.611C1 14.974 2.974 16 5.592 16c2.618 0 4.592-1.026 4.592-2.388a5.276 5.276 0 0 0-1.34-3.565.61.61 0 0 0-.866-.04zM14.66 6.355a.61.61 0 0 0-1.044.224.618.618 0 0 0 .139.605 4.048 4.048 0 0 1 1.02 2.735c0 .409-1.278 1.158-3.367 1.158a.614.614 0 0 0-.612.615c0 .34.274.616.612.616 2.618 0 4.592-1.027 4.592-2.389a5.278 5.278 0 0 0-1.34-3.564z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.592 9.846A3.07 3.07 0 0 0 8.653 6.77a3.07 3.07 0 0 0-3.061-3.077A3.07 3.07 0 0 0 2.53 6.77a3.073 3.073 0 0 0 3.06 3.077zm0-4.923c1.014 0 1.837.827 1.837 1.846 0 1.02-.823 1.846-1.837 1.846A1.841 1.841 0 0 1 3.755 6.77a1.843 1.843 0 0 1 1.837-1.846zM11.408 6.154a3.07 3.07 0 0 0 3.061-3.077A3.07 3.07 0 0 0 11.408 0a3.07 3.07 0 0 0-3.061 3.077 3.073 3.073 0 0 0 3.061 3.077zm0-4.923c1.014 0 1.837.826 1.837 1.846s-.823 1.846-1.837 1.846a1.841 1.841 0 0 1-1.837-1.846 1.843 1.843 0 0 1 1.837-1.846z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResultantMembers);
export default __webpack_public_path__ + "static/media/resultant-members.dc4fd1a7a19e1db4a32fbd117d300229.svg";
export { ForwardRef as ReactComponent };